import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import {ConfigStore} from "~/chat/ts/store/Config";
import {StorageInstance} from "~/ts/library/storage/StorageFactory";
import EulaModalMessage from "~/chat/vue/widget/form/fields/EulaModalMessage.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed, ref} from "vue";
import ChatSwitchInput from "~/chat/vue/widget/form/fields/ChatSwitchInput.vue";
import {SwitchInputInterface} from "~/cabinet/vue/interface/form/elements/Interfaces";


const __default__ = {
    name: "ChatEulaInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

const EULA_ACCEPTED = "eulaAccepted";

let props = __props;

let emits = __emit;

let {exposedObject} = useChatFormInput(props);

__expose(exposedObject);

let eulaDisplayed = ref(false);

let eulaConfig = computed(() => {
    return ConfigStore.siteParams.value.params.siteChatOptions.eula;
});

let switchField = computed<SwitchInputInterface>(() => {
    return {
        ...props.field,
        descrAfterSwitch: eulaConfig.value.checkboxText
    };
})

function onInput(value?: boolean) {
    StorageInstance.set(EULA_ACCEPTED, value);
    emits('update:modelValue', value)
}

if (eulaConfig.value.enabledByDefault || StorageInstance.get(EULA_ACCEPTED)) {
    emits("update:modelValue", true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatSwitchInput, {
    field: _unref(switchField),
    required: _unref(props).required,
    error: _unref(props).error,
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": onInput
  }, {
    "after-descr": _withCtx(() => [
      _createElementVNode("a", {
        class: "link-dashed ml-1",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_isRef(eulaDisplayed) //@ts-ignore
 ? eulaDisplayed.value = true : eulaDisplayed = true), ["stop","prevent"]))
      }, "Ознакомиться"),
      (_unref(eulaDisplayed))
        ? (_openBlock(), _createBlock(EulaModalMessage, {
            key: 0,
            visible: _unref(eulaDisplayed),
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(eulaDisplayed) ? (eulaDisplayed).value = $event : eulaDisplayed = $event))
          }, null, 8, ["visible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["field", "required", "error", "model-value"]))
}
}

})